import { RouteConfig } from 'vue-router'

import digitalSportsIcon from '../assets/images/icon_menu_sports_digital_portrait@2x.png'
import digitalSportsIconActive from '../assets/images/icon_menu_sports_digital_portrait_active@2x.png'
import { Role } from '@/models/role'

const Layout = () => import('../views/Layout.vue')
const WorkContestAssessment = () => import('../views/work-contest/ProjectAssessment.vue')
const WorkContestProjects = () => import('../views/work-contest/ContestProjects.vue')

export const workContestDetailRoute: RouteConfig = {
  path: '/work-contest/work-contest-assessment',
  name: 'work_contest_assessment',
  component: WorkContestAssessment,
  props: (route) => ({ ...route.query }),
  meta: {
    title: '作业设计大赛',
    showMenu: false,
  },
}

export const workContestProjectsRoute: RouteConfig = {
  path: '/work-contest/work-contest-projects',
  name: 'work_contest_projects',
  component: WorkContestProjects,
  meta: {
    title: '作业设计大赛',
    showMenu: false,
  },
}

export default [
  {
    path: '/work-contest',
    name: 'work_contest',
    component: Layout,
    redirect: workContestProjectsRoute.path,
    meta: {
      title: '作业设计大赛',
      icon: digitalSportsIcon,
      iconActive: digitalSportsIconActive,
      showMenu: true,
      roles: [Role.HWJudge],
    },
    children: [workContestProjectsRoute, workContestDetailRoute],
  },
]
